import { StyleSheet } from '@react-pdf/renderer';

const colorDark = '#222';
const colorDark2 = '#666';
const colorGray = '#e3e3e3';
const colorWhite = '#fff';

const styles = StyleSheet.create({
    header: {
        backgroundColor: colorDark,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: 20,
    },
    logo: {
        width: 100,
    },
    contractInfo: {
        textAlign: 'center',
        alignItems: 'center',
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    location: {
        fontSize: 10,
        marginBottom: 4,
    },
    contractBox: {
        border: '1pt solid black',
        padding: 4,
        minWidth: 100,
        alignItems: 'center',
    },
    contractId: {
        fontSize: 10,
        color: '#043865',
    },
    dark: {
        color: colorDark,
    },
    white: {
        color: colorWhite,
    },
    bgDark: {
        backgroundColor: colorDark2,
    },
    bgGray: {
        backgroundColor: colorGray,
    },
    page: {
        backgroundColor: colorWhite,
        fontSize: 12,
        color: '#555',
        padding: 40,
    },
    textCenter: {
        textAlign: 'center',
    },
    infoRow: {
        flexDirection: 'row',
        width: '100%',
    },

    infoCell: {
        border: '1pt solid black',
        padding: 4,
        flex: 1,
        fontSize: 10,
    },
    minCell: {
        flex: 0.5,
        minWidth: 40,
    },
    col: { flexGrow: 1, flexShrink: 0, flexBasis: '0%' },
    'col-auto': { flexGrow: 0, flexShrink: 0, width: 'auto' },
    'col-1': { flexBasis: '8.33%', maxWidth: '8.33%' },
    'col-2': { flexBasis: '16.66%', maxWidth: '16.66%' },
    'col-3': { flexBasis: '25%', maxWidth: '25%' },
    'col-4': { flexBasis: '33.33%', maxWidth: '33.33%' },
    'col-5': { flexBasis: '41.66%', maxWidth: '41.66%' },
    'col-6': { flexBasis: '50%', maxWidth: '50%' },
    'col-7': { flexBasis: '58.33%', maxWidth: '58.33%' },
    'col-8': { flexBasis: '66.66%', maxWidth: '66.66%' },
    'col-9': { flexBasis: '75%', maxWidth: '75%' },
    'col-10': { flexBasis: '83.33%', maxWidth: '83.33%' },
    'col-11': { flexBasis: '91.66%', maxWidth: '91.66%' },
    'col-12': { flexBasis: '100%', maxWidth: '100%' },
    border: { border: '1pt solid black', padding: 4 },
    'text-center': { textAlign: 'center' },
    bold: { fontWeight: 'bold' },
    'text-center': {
        textAlign: 'center',
    },
    border: {
        border: '1pt solid black',
        padding: 4,
    },totalsTable: {
  width: '100%',
  border: '1px solid #000',
  borderCollapse: 'collapse',
  marginTop: 10,
},
totalsRow: {
  display: 'flex',
  flexDirection: 'row',
  borderBottom: '1px solid #ccc',
},
totalsLabel: {
  flex: 1,
  padding: 6,
  backgroundColor: '#f2f2f2',
  borderRight: '1px solid #ccc',
},
totalsCell: {
  flex: 1,
  padding: 6,
  textAlign: 'right',
},
totalsRowTotal: {
  backgroundColor: '#fff',
  fontWeight: 'bold',
},signatureRow: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: 8,
},

signatureField: {
  borderBottomWidth: 1,
  borderColor: '#000',
  paddingBottom: 2,
  minHeight: 20,
  justifyContent: 'flex-end',
},

signatureLabel: {
  fontSize: 8,
  color: '#000',
  marginTop: 2,
},

signatureValue: {
  fontSize: 11,
  fontFamily: 'Times-Roman', // or use your desired font to match
},
});

export default styles;
